import React, { useState } from "react";

function ProfilePage() {
  // Изначальные данные пользователя
  const [firstName, setFirstName] = useState("Иван");
  const [lastName, setLastName] = useState("Иванов");
  const [email, setEmail] = useState("ivan@example.com");

  // Поля паролей
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  // Показывать/скрывать пароли
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // Общие сообщения об успехе
  const [successMsg, setSuccessMsg] = useState("");

  // ---------------- Валидация ----------------
  // Имя/фамилия: 2..50 символов
  const isValidName = (val) => val.length >= 2 && val.length <= 50;

  // Email (упрощённый RegExp)
  const emailRegex = /^[A-Za-z0-9._%+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}$/;
  const isEmailValid = (val) => emailRegex.test(val.trim());

  // Пароль: 4..50 символов, латиница + цифры
  const passwordRegex = /^[A-Za-z0-9]{4,50}$/;
  const isPasswordValid = (val) => passwordRegex.test(val);

  // Текущий пароль (мок, правильный "test123")
  const mockCorrectCurrentPassword = "test123";

  // ---------------- Сообщения об ошибках ----------------
  const getFirstNameError = () => {
    if (firstName.trim().length === 0) return "";
    if (!isValidName(firstName)) {
      return "Имя должно быть от 2 до 50 символов.";
    }
    return "";
  };

  const getLastNameError = () => {
    if (lastName.trim().length === 0) return "";
    if (!isValidName(lastName)) {
      return "Фамилия должна быть от 2 до 50 символов.";
    }
    return "";
  };

  const getEmailError = () => {
    if (email.trim().length === 0) return "";
    if (!isEmailValid(email)) {
      return "Некорректный формат email.";
    }
    return "";
  };

  const getCurrentPasswordError = () => {
    if (currentPassword.trim().length === 0) return "";
    if (currentPassword !== mockCorrectCurrentPassword) {
      return "Текущий пароль введён неверно.";
    }
    return "";
  };

  const getNewPasswordError = () => {
    if (newPassword.trim().length === 0) return "";
    if (!isPasswordValid(newPassword)) {
      return "Пароль должен быть от 4 до 50 символов, только латиница и цифры.";
    }
    return "";
  };

  const getConfirmPasswordError = () => {
    if (confirmPassword.trim().length === 0) return "";
    if (confirmPassword !== newPassword) {
      return "Пароли не совпадают.";
    }
    return "";
  };

  // ---------------- Проверка всей формы ----------------
  const isFormValid = () => {
    // Если есть хоть одна ошибка, форма невалидна
    if (
      getFirstNameError() ||
      getLastNameError() ||
      getEmailError() ||
      (currentPassword && getCurrentPasswordError()) ||
      (newPassword && getNewPasswordError()) ||
      (confirmPassword && getConfirmPasswordError())
    ) {
      return false;
    }
    return true;
  };

  // ---------------- Обработка сабмита ----------------
  const handleSaveChanges = (e) => {
    e.preventDefault();

    // Если форма невалидна
    if (!isFormValid()) {
      alert("Исправьте ошибки в форме.");
      return;
    }

    // Сбрасываем поля паролей
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");

    // Показываем сообщение об успехе
    setSuccessMsg("Профиль успешно обновлён.");
  };

  // ---------------- Ошибки ----------------
  const firstNameError = getFirstNameError();
  const lastNameError = getLastNameError();
  const emailError = getEmailError();
  const currentPasswordError = getCurrentPasswordError();
  const newPasswordError = getNewPasswordError();
  const confirmPasswordError = getConfirmPasswordError();

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f0f0f0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <form
        onSubmit={handleSaveChanges}
        style={{
          background: "#fff",
          padding: "2rem",
          borderRadius: "8px",
          boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          width: "400px",
        }}
      >
        <h2 style={{ marginBottom: "1rem", textAlign: "center" }}>Мой профиль</h2>

        {/* Успех */}
        {successMsg && (
          <div
            style={{
              color: "green",
              fontSize: "0.9rem",
              marginBottom: "1rem",
              textAlign: "center",
            }}
          >
            {successMsg}
          </div>
        )}

        {/* Блок "Имя" */}
        <div className="form-group" style={{ marginBottom: "1rem" }}>
          <label>Имя</label>
          <input
            type="text"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            style={{ width: "100%", padding: "0.5rem" }}
          />
          {firstNameError && (
            <p style={{ color: "red", fontSize: "0.9rem", marginTop: "0.3rem" }}>
              {firstNameError}
            </p>
          )}
        </div>

        {/* Блок "Фамилия" */}
        <div className="form-group" style={{ marginBottom: "1rem" }}>
          <label>Фамилия</label>
          <input
            type="text"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            style={{ width: "100%", padding: "0.5rem" }}
          />
          {lastNameError && (
            <p style={{ color: "red", fontSize: "0.9rem", marginTop: "0.3rem" }}>
              {lastNameError}
            </p>
          )}
        </div>

        {/* Блок "Email" */}
        <div className="form-group" style={{ marginBottom: "1rem" }}>
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ width: "100%", padding: "0.5rem" }}
          />
          {emailError && (
            <p style={{ color: "red", fontSize: "0.9rem", marginTop: "0.3rem" }}>
              {emailError}
            </p>
          )}
        </div>

        {/* Текущий пароль */}
        <div className="form-group" style={{ marginBottom: "1rem" }}>
          <label>Текущий пароль</label>
          <div style={{ position: "relative" }}>
            <input
              type={showCurrentPassword ? "text" : "password"}
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              style={{ width: "100%", padding: "0.5rem", paddingRight: "40px" }}
            />
            <button
              type="button"
              onClick={() => setShowCurrentPassword(!showCurrentPassword)}
              style={{
                position: "absolute",
                top: "50%",
                right: "8px",
                transform: "translateY(-50%)",
                background: "transparent",
                border: "none",
                cursor: "pointer",
              }}
            >
              {showCurrentPassword ? "Скрыть" : "Показать"}
            </button>
          </div>
          {currentPasswordError && (
            <p style={{ color: "red", fontSize: "0.9rem", marginTop: "0.3rem" }}>
              {currentPasswordError}
            </p>
          )}
        </div>

        {/* Новый пароль */}
        <div className="form-group" style={{ marginBottom: "1rem" }}>
          <label>Новый пароль</label>
          <div style={{ position: "relative" }}>
            <input
              type={showNewPassword ? "text" : "password"}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              style={{ width: "100%", padding: "0.5rem", paddingRight: "40px" }}
            />
            <button
              type="button"
              onClick={() => setShowNewPassword(!showNewPassword)}
              style={{
                position: "absolute",
                top: "50%",
                right: "8px",
                transform: "translateY(-50%)",
                background: "transparent",
                border: "none",
                cursor: "pointer",
              }}
            >
              {showNewPassword ? "Скрыть" : "Показать"}
            </button>
          </div>
          {newPasswordError && (
            <p style={{ color: "red", fontSize: "0.9rem", marginTop: "0.3rem" }}>
              {newPasswordError}
            </p>
          )}
        </div>

        {/* Подтверждение нового пароля */}
        <div className="form-group" style={{ marginBottom: "1rem" }}>
          <label>Подтверждение нового пароля</label>
          <div style={{ position: "relative" }}>
            <input
              type={showConfirmPassword ? "text" : "password"}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              style={{ width: "100%", padding: "0.5rem", paddingRight: "40px" }}
            />
            <button
              type="button"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              style={{
                position: "absolute",
                top: "50%",
                right: "8px",
                transform: "translateY(-50%)",
                background: "transparent",
                border: "none",
                cursor: "pointer",
              }}
            >
              {showConfirmPassword ? "Скрыть" : "Показать"}
            </button>
          </div>
          {confirmPasswordError && (
            <p style={{ color: "red", fontSize: "0.9rem", marginTop: "0.3rem" }}>
              {confirmPasswordError}
            </p>
          )}
        </div>

        {/* Кнопка "Сохранить" */}
        <button
          type="submit"
          disabled={!isFormValid()}
          style={{
            width: "100%",
            padding: "0.7rem",
            backgroundColor: isFormValid() ? "#007bff" : "#cccccc",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: isFormValid() ? "pointer" : "not-allowed",
          }}
        >
          Сохранить
        </button>
      </form>
    </div>
  );
}

export default ProfilePage;
